import React,{Component} from 'react';
import './style.css';

export default class Footer extends Component {
    render() { 
        return(
            <div className='footer'>
                <p>Developed by Shyam Pradhan</p>
            </div>
        );
    }
}
 
